export interface IListSolicitacoesDto{
    sd92id: number,
    sd41id: number,
    sd41nome: string
    sd40id: number,
    sd40cnpj: string,
    sd40nome: string
    sd92status: number
}

export interface IPaginationDto {
    values: Array<IListSolicitacoesDto>,
    count: number
}

export interface IAprovarSolicitacaoDto{
    sd92id: number
    status: string
    motivo?: string
}

export interface ISd92Dto{
    sd92id: number;
    sd92cliente: {
        sd40id: number;
        sd40cnpj: string;
        sd40nome: string;
        sd40contato: string;
        sd40ddd1: string;
        sd40fone1: string;
        sd40email: string
    };
    sd92status: number;
    sd92numcontrato: number;
    sd92dtcontrato: string;
    sd92representante: {
        sd41id: number;
        sd41codigo: string;
        sd41nome: string
    };
    sd92aquisicao: number;
    sd92locacao: number;
    sd92sampalmandroid: number;
    sd92sampalmios: number;
    sd92quantidade: number;
    sd92dtprovisoria: string;
    sd92motivsolicitacao: number;
    sd92motivo: string;
    sd92du: string;
    sd921s: Array<ISd921Dto>
}

export interface ISd921Dto{
    sd921id: number;
    sd921sistema: {
        sd11id: number;
        sd11sigla: string;
        sd11descr: string;
        sd11preco: number
    };
}

export enum sd92motivsolicitacaoEnum{
    DEMONSTRACAO=0,
    IMPLANTACAO=1,
    OFICIAL=2,
}

export enum sd92statusEnum{
    SOLICITADO=0,
    APROVADO=1,
    RECUSADO=2
}